export default function Organization() {
  const orgStructure = [
    {
      level: 1,
      title: '대표이사',
      name: '대표',
      color: 'bg-blue-600'
    },
    {
      level: 2,
      departments: [
        {
          title: '사무국',
          name: '사무국장',
          color: 'bg-teal-500',
          teams: [
            { name: '총무팀', description: '행정 및 재무 관리' },
            { name: '홍보팀', description: '대외 홍보 및 마케팅' }
          ]
        },
        {
          title: '사업본부',
          name: '본부장',
          color: 'bg-purple-500',
          teams: [
            { name: '교육지원팀', description: '아동·청소년 교육 지원' },
            { name: '의료지원팀', description: '저소득층 의료비 지원' },
            { name: '생활지원팀', description: '생필품 및 푸드뱅크 운영' }
          ]
        },
        {
          title: '봉사활동본부',
          name: '본부장',
          color: 'bg-orange-500',
          teams: [
            { name: '지역봉사팀', description: '지역사회 봉사활동' },
            { name: '자원봉사관리팀', description: '자원봉사자 모집 및 관리' }
          ]
        }
      ]
    }
  ];

  return (
    <section id="조직도" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block bg-blue-50 text-blue-700 px-4 py-2 rounded-full text-sm font-semibold mb-4">
            조직도
          </div>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            <strong>유앤아이월드</strong> 조직 구성
          </h2>
          <p className="text-gray-600 text-lg">
            체계적인 조직으로 효율적인 나눔을 실천합니다
          </p>
        </div>

        <div className="space-y-12">
          {/* Level 1: CEO */}
          <div className="flex justify-center">
            <div className="bg-blue-600 text-white rounded-2xl px-12 py-8 shadow-xl text-center min-w-[280px]">
              <div className="text-2xl font-bold mb-2">{orgStructure[0].title}</div>
              <div className="text-xl font-medium">{orgStructure[0].name}</div>
            </div>
          </div>

          {/* Connector Line */}
          <div className="flex justify-center">
            <div className="w-1 h-12 bg-gray-300"></div>
          </div>

          {/* Level 2: Departments */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {orgStructure[1].departments.map((dept, index) => (
              <div key={index} className="space-y-6">
                {/* Department Head */}
                <div className={`${dept.color} text-white rounded-2xl px-8 py-6 shadow-lg text-center`}>
                  <div className="text-xl font-bold mb-2">{dept.title}</div>
                  <div className="text-lg font-medium">{dept.name}</div>
                </div>

                {/* Connector Line */}
                <div className="flex justify-center">
                  <div className="w-1 h-8 bg-gray-300"></div>
                </div>

                {/* Teams */}
                <div className="space-y-4">
                  {dept.teams.map((team, teamIndex) => (
                    <div
                      key={teamIndex}
                      className="bg-gray-50 rounded-xl px-6 py-5 border-2 border-gray-200 hover:border-blue-300 hover:shadow-md transition-all duration-300"
                    >
                      <div className="font-bold text-gray-900 text-lg mb-1">
                        {team.name}
                      </div>
                      <div className="text-gray-600 text-sm">
                        {team.description}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Additional Info */}
        <div className="mt-16 bg-blue-50 rounded-2xl p-8 text-center">
          <div className="flex flex-wrap justify-center gap-8 text-gray-700">
            <div>
              <div className="text-3xl font-bold text-blue-600 mb-2">15+</div>
              <div className="text-sm font-medium">전문 인력</div>
            </div>
            <div className="w-px bg-gray-300 hidden md:block"></div>
            <div>
              <div className="text-3xl font-bold text-blue-600 mb-2">500+</div>
              <div className="text-sm font-medium">자원봉사자</div>
            </div>
            <div className="w-px bg-gray-300 hidden md:block"></div>
            <div>
              <div className="text-3xl font-bold text-blue-600 mb-2">1,000+</div>
              <div className="text-sm font-medium">정기후원자</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
